import { useEffect } from 'react'
import { useDispatch, useStore } from 'react-redux'

import { fetchUnreadCount } from '../features/notifications/notifications'
import { selectCountFetchedAt } from '../features/notifications/selectors'

export const POLL_INTERVAL_MS = 60000

export const useNotificationsPoll = () => {
  const dispatch = useDispatch()
  const store = useStore()

  useEffect(() => {
    const isVisible = () => document.visibilityState === 'visible'
    const isStale = () => Date.now() - selectCountFetchedAt(store.getState()) >= POLL_INTERVAL_MS
    const refreshIfStale = () => {
      if (isVisible() && isStale()) dispatch(fetchUnreadCount())
    }

    refreshIfStale()

    const timer = setInterval(() => {
      if (isVisible()) dispatch(fetchUnreadCount())
    }, POLL_INTERVAL_MS)

    window.addEventListener('focus', refreshIfStale)
    document.addEventListener('visibilitychange', refreshIfStale)

    return () => {
      clearInterval(timer)
      window.removeEventListener('focus', refreshIfStale)
      document.removeEventListener('visibilitychange', refreshIfStale)
    }
  }, [dispatch, store])
}
